import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { useStores } from './hooks/use-stores';
import { LoginPage, HomePage, SpinCentered, AppVersion } from '@/comp';
import gtag from './utils/gtag';
import SsoLoginPage from './comp/pages/SsoLoginPage/SsoLoginPage';
import { NavigateToLogin } from './comp/NavigateToLogin';
import PdfReportsPage from './comp/pages/PdfReports/PdfReportsPage';
import { useIsMobile } from './hooks/useIsMobile';

const App = observer(() => {
  const { userStore } = useStores();
  const location = useLocation();
  const { isMobile } = useIsMobile();

  useEffect(() => {
    const { pathname } = location;
    if (userStore.isReady && pathname && gtag.getPageName(pathname)) {
      gtag.setUserProperties(userStore.user, pathname);
    }
  }, [location, userStore.user]);

  return (
    <>
      {!isMobile && <AppVersion />}

      {userStore.isStoreReady ? (
        <Routes>
          <Route path="/login/sso/*" element={<SsoLoginPage />} />
          <Route path="/login/*" element={<LoginPage />} />

          <Route
            path="/home/*"
            element={userStore.isAuthenticatedAndAccepted ? <HomePage /> : <NavigateToLogin from={location} />}
          />

          <Route path="pdf-reports/:stationId/*" element={<PdfReportsPage />} />

          <Route path="/*" element={<Navigate replace to="/home" />} />
        </Routes>
      ) : (
        <SpinCentered />
      )}
    </>
  );
});

export default App;
